var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content ai-reconciliation" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            on: { "tab-remove": _vm.handleTabRemove },
            model: {
              value: _vm.activeTab,
              callback: function($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab"
            }
          },
          _vm._l(_vm.tabs, function(tab) {
            return _c(
              "el-tab-pane",
              {
                key: tab.name,
                attrs: {
                  label: tab.label,
                  name: tab.name,
                  closable: tab.closable
                }
              },
              [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    "task-id": tab.taskId,
                    "refresh-key": tab.refreshKey
                  },
                  on: {
                    "create-task": _vm.openCreateTab,
                    "view-task": _vm.openTaskTab,
                    back: _vm.backToBoard,
                    created: _vm.handleTaskCreated,
                    "open-compare": _vm.openCompareTab
                  }
                })
              ],
              1
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }